import { ImisMessageType } from "./imis.models";

/** Configuration for a toast/status message, including its content, type, auto-dismiss behavior, and optional confirmation dialog. */
export class ToastMessageProperties {
    messageId: string;
    message: string;
    messageType?: ImisMessageType;
    autoDismiss?: boolean;
    autoDismissSeconds?: number;
    confirmationDialog?: ToastMessageConfirmationProperties;

    /**
     * Creates a ToastMessageProperties instance defaulting to an informational message that auto-dismisses after 3 seconds.
     */
    constructor() {
        this.messageType = ImisMessageType.INFORMATION;
        this.autoDismiss = true;
        this.autoDismissSeconds = 3;
    }
}

/** Callback handlers invoked when a toast message's confirmation dialog is confirmed or cancelled. */
export interface ToastMessageConfirmationProperties {
    onConfirm: () => void;
    onCancel: () => void;
}
